var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("title", function () {
        return [
          _c(
            "h5",
            { staticClass: "grey-color mt-3 mb-1 main_text font-weight-bold" },
            [_vm._v("Разногласия по контракту")]
          ),
        ]
      }),
      _c("div", { staticClass: "table-responsive" }, [
        _c(
          "table",
          { staticClass: "table b-table" },
          _vm._l(_vm.disagreements, function (disagreement, index) {
            return _c(
              "fragment",
              { key: index },
              [
                _c("tr", [
                  _c(
                    "th",
                    { staticClass: "py-1", staticStyle: { width: "1px" } },
                    [_vm._v("№")]
                  ),
                  _c("th", { staticClass: "text-nowrap py-1" }, [
                    _vm._v("Протокол разногласий (поставщик)"),
                  ]),
                  _c("th", { staticClass: "py-1" }, [
                    _vm._v("Комментарий поставщика"),
                  ]),
                  _c(
                    "th",
                    { staticClass: "py-1", staticStyle: { width: "100px" } },
                    [_vm._v("Направлен")]
                  ),
                  _c(
                    "th",
                    { staticClass: "py-1", staticStyle: { width: "50px" } },
                    [_vm._v("Подпись")]
                  ),
                ]),
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "py-1",
                      attrs: { rowspan: !disagreement.reply_file ? 1 : 3 },
                    },
                    [_vm._v(_vm._s(index + 1))]
                  ),
                  _c("td", { staticClass: "text-nowrap py-1" }, [
                    _c(
                      "a",
                      {
                        staticClass: "atmo-button-link",
                        attrs: {
                          href: _vm.$getAttachmentDownloadLink(
                            disagreement.dispute_file.id
                          ),
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(disagreement.dispute_file.name))]
                    ),
                  ]),
                  _c("td", { staticClass: "py-1" }, [
                    _vm._v(_vm._s(disagreement.dispute_comment)),
                  ]),
                  _c("td", { staticClass: "text-nowrap py-1" }, [
                    _vm._v(
                      _vm._s(_vm.getDateTimeFormat(disagreement.created_at))
                    ),
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center text-nowrap py-1" },
                    [
                      _c("action-button-small", {
                        attrs: {
                          icon: "clipboard-check",
                          title: "Информация о подписи",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showSign(
                              false,
                              disagreement.dispute_signature
                            )
                          },
                        },
                      }),
                      disagreement.dispute_signature.poa_number &&
                      disagreement.dispute_signature.poa_check_link
                        ? _c("action-button-small", {
                            staticClass: "ml-1",
                            attrs: {
                              icon: "clipboard-plus",
                              title: "Информация о МЧД",
                              variant: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showSign(
                                  true,
                                  disagreement.dispute_signature
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _c("action-button-small", {
                        staticClass: "ml-1",
                        attrs: {
                          icon: "cloud-download",
                          title: "Скачать файл подписи",
                          variant: "outline",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.download(
                              disagreement.dispute_signature.md5,
                              false,
                              disagreement.dispute_file.name
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                disagreement.reply_file
                  ? [
                      _c("tr", [
                        _c("th", { staticClass: "text-nowrap py-1" }, [
                          _vm._v("Ответ на протокол разногласий (заказчик)"),
                        ]),
                        _c("th", { staticClass: "py-1" }, [
                          _vm._v("Комментарий заказчика"),
                        ]),
                        _c("th", { staticClass: "py-1" }, [
                          _vm._v("Направлен"),
                        ]),
                        _c("th", { staticClass: "py-1" }, [_vm._v("Подпись")]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "text-nowrap py-1" }, [
                          _c(
                            "a",
                            {
                              staticClass: "atmo-button-link",
                              attrs: {
                                href: _vm.$getAttachmentDownloadLink(
                                  disagreement.reply_file.id
                                ),
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(disagreement.reply_file.name))]
                          ),
                        ]),
                        _c("td", { staticClass: "py-1" }, [
                          _vm._v(_vm._s(disagreement.reply_comment)),
                        ]),
                        _c("td", { staticClass: "text-nowrap py-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getDateTimeFormat(disagreement.updated_at)
                            )
                          ),
                        ]),
                        _c(
                          "td",
                          { staticClass: "text-center text-nowrap py-1" },
                          [
                            _c("action-button-small", {
                              attrs: {
                                icon: "clipboard-check",
                                title: "Информация о подписи",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showSign(
                                    true,
                                    disagreement.reply_signature
                                  )
                                },
                              },
                            }),
                            disagreement.reply_signature.poa_number &&
                            disagreement.reply_signature.poa_check_link
                              ? _c("action-button-small", {
                                  staticClass: "ml-1",
                                  attrs: {
                                    icon: "clipboard-plus",
                                    title: "Информация о МЧД",
                                    variant: "warning",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showSign(
                                        true,
                                        disagreement.reply_signature
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("action-button-small", {
                              staticClass: "ml-1",
                              attrs: {
                                icon: "cloud-download",
                                title: "Скачать файл подписи",
                                variant: "outline",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.download(
                                    disagreement.reply_signature.md5,
                                    true,
                                    disagreement.reply_file.name
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
          1
        ),
      ]),
      _vm.signData.signature
        ? _c("show-sign-modal", {
            attrs: {
              signature: _vm.signData.signature,
              "org-is-customer": _vm.signData.isCustomer,
              show: _vm.showSignModal,
            },
            on: {
              close: function ($event) {
                _vm.showSignModal = false
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }